import { FIELD, PADDLE, VIEW } from '../core/config.js';

/** Vaus. Tracks a target x and eases its width when a capsule resizes it. */

export const PADDLE_MODE = Object.freeze({
  NORMAL: 'normal',
  LASER: 'laser',
  CATCH: 'catch',
});

export function createPaddle() {
  return {
    cx: VIEW.W / 2,
    y: PADDLE.top,
    h: PADDLE.height,
    w: PADDLE.widths.normal,
    targetW: PADDLE.widths.normal,
    sizeKey: 'normal',
    mode: PADDLE_MODE.NORMAL,
    vx: 0,
    /** Set while the paddle is escaping through a warp gate. */
    warping: false,
    /** Cosmetic timer for the materialise animation after a life is lost. */
    spawnAnim: 0,
  };
}

export function setPaddleSize(paddle, sizeKey) {
  paddle.sizeKey = sizeKey;
  paddle.targetW = PADDLE.widths[sizeKey] ?? PADDLE.widths.normal;
}

export function resetPaddle(paddle) {
  paddle.cx = VIEW.W / 2;
  paddle.vx = 0;
  paddle.mode = PADDLE_MODE.NORMAL;
  paddle.warping = false;
  paddle.spawnAnim = 0.6;
  setPaddleSize(paddle, 'normal');
  paddle.w = paddle.targetW;
}

export function paddleLeft(paddle) {
  return paddle.cx - paddle.w / 2;
}

export function paddleRight(paddle) {
  return paddle.cx + paddle.w / 2;
}

/**
 * Move the paddle toward targetX and ease its width.
 * @param {object} paddle
 * @param {number} dt
 * @param {number} targetX desired centre x in logical pixels
 */
export function updatePaddle(paddle, dt, targetX) {
  if (paddle.spawnAnim > 0) paddle.spawnAnim = Math.max(0, paddle.spawnAnim - dt);

  const delta = paddle.targetW - paddle.w;
  if (delta !== 0) {
    const step = PADDLE.morphSpeed * dt;
    paddle.w += Math.abs(delta) <= step ? delta : Math.sign(delta) * step;
  }

  const half = paddle.w / 2;
  // The warp gate is the only time Vaus is allowed past the right wall.
  const maxX = paddle.warping ? VIEW.W + half : FIELD.right - half;
  const clamped = Math.max(FIELD.left + half, Math.min(maxX, targetX));
  const previous = paddle.cx;
  paddle.cx = clamped;
  paddle.vx = dt > 0 ? (paddle.cx - previous) / dt : 0;
}

/** Muzzle positions for the twin laser cannons. */
export function laserMuzzles(paddle) {
  const inset = Math.min(10, paddle.w * 0.18);
  return [paddleLeft(paddle) + inset, paddleRight(paddle) - inset];
}
